import axios from 'axios';
import { BASE_HEADERS, BASE_URI, METHOD } from './constants';
import { showErrorToast } from '../utils/helpers';

export default class RequestManager {
	static get(uri, params) {
		return this.request(uri, METHOD.GET, params);
	}

	static post(uri, params) {
		return this.request(uri, METHOD.POST, params);
	}

	static put(uri, params) {
		return this.request(uri, METHOD.PUT, params);
	}

	static request(endpoint, method, params) {
		return axios
			.request({ headers: BASE_HEADERS, method, url: `${BASE_URI}${endpoint}`, ...params })
			.then(response => response.data)
			.catch(err => {
				const message = err?.response?.data?.message || 'Bir sorun oluştu, lütfen daha sonra tekrar deneyiniz.';
				showErrorToast(message);
				return err?.response?.data || 'error';
			});
	}
}
